var map = {
	"./1.webp": 2207,
	"./2.webp": 9214,
	"./3.webp": 5241,
	"./4.webp": 5088,
	"./5.webp": 851,
	"./6.webp": 3202,
	"./7.webp": 7917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4374;